module.exports = __webpack_public_path__ + "img/Shaman-orc-f-70.21f27f7e.gif";